import {observable, makeObservable} from 'mobx';
import {DomainObject} from 'shared/store';
import {Employee} from 'main/stores/employees';
import Cycle from './Cycle';

class CheckinRelation extends DomainObject {
  reviewee;
  reviewer;
  cycle;
  frequency;
  daysSinceLastCheckin;
  totalDays;
  lastCheckinId;
  status;

  _relations = {
    reviewee: Employee,
    reviewer: Employee,
    cycle: Cycle
  };

  constructor(other) {
    super();

    makeObservable(this, {
      reviewee: observable,
      reviewer: observable,
      cycle: observable,
      frequency: observable,
      daysSinceLastCheckin: observable,
      totalDays: observable,
      lastCheckinId: observable,
      status: observable
    });

    this.merge(other);
  }
}

export default CheckinRelation;
